<!-- 直播记录-->
<template>
  <div>
    <div class="box">
      <span>{{$route.query.name}}的直播记录</span>
      <div>
        <span v-for="item in recordDetail" :key="item.key" class="num">
          {{item.label}}:
          <a-tooltip>
            <template slot="title">
              {{item.value}}
            </template>
            {{item.value}}
          </a-tooltip>
        </span>
      </div>
    </div>
    <x-tabula
      ref="table"
      apiOrigin="PHP"
      :dataSource="dataSource"
      rowKey="record_id"
      :searchList="searchList"
      :columns="columns"
      :tableOptList="tableOptList"
      :rowOptLen="4"
      :rowOptList="rowOptList"
      :searchParams.sync="searchParams"
      :listApi="listApi"
      :rowSelection="false"
    >
      <template slot="opt_action_t" slot-scope="{row}">
        <div style="color: #3fa9ff;cursor: pointer;" v-if="row.status" @click="goToRoom(row)">查看</div>
        <div style="color: #ccc;" v-else>查看</div>
      </template>
    </x-tabula>
  </div>
</template>

<script>
export default {
  name: 'broadcastRecord',
  data () {
    return {
      searchList: [
        { label: '', props: ['create_date'], placeholder: ['直播时间', '直播时间'], options: [], inputType: 'dateTimePick' }
      ],
      tableOptList: [],
      rowOptList: [
        { text: '查看', handle: (row) => this.goToRoom(row), permi: ['community:broadcastRecord:show'] }
      ],
      columns: [
        { title: '直播时间段', dataIndex: 'create_date', align: 'left', width: '' },
        { title: '直播时长', dataIndex: 'time_long', align: 'left', width: '' },
        { title: '观众数', dataIndex: 'view_num', align: 'left', width: '' },
        { title: '获赞数', dataIndex: 'praise_num', align: 'left', width: '' },
        { title: '评论数', dataIndex: 'comment_num', align: 'left', width: '' },
        { title: '增加粉丝数', dataIndex: 'friend_num', align: 'left', width: '' },
        { title: '操作', dataIndex: 'action', align: 'left', width: '', scopedSlots: {customRender: 'action_t'} }
      ],
      dataSource: [],
      searchParams: {
        create_date: undefined
      },
      listApi: {
        url: '', // live/anchors
        resHandle: this.resHandle, // this.resHandle
        searchHandle: '' // searchHandle
      },
      recordDetail: [
        { label: '累计观众', value: '12', key: 'view_num' },
        { label: '累计获赞', value: '32', key: 'praise_num' },
        { label: '累计评论', value: '121', key: 'comment_num' },
        { label: '累计粉丝', value: '323', key: 'friend_num' }
      ]
    };
  },
  created () {
    if (this.$route.query.id) {
      this.listApi.url = `/live/anchors/${this.$route.query.id}/records`;
      this.getDetail(this.$route.query.id);
    }
  },
  mounted () {},
  methods: {
    getDetail (id) {
      this.$get({
        url: `/live/anchors/${id}/statics`
      }).then(({data}) => {
        for (let k in data) {
          this.recordDetail.forEach(item => {
            if (item.key === k) {
              item.value = data[k];
            }
          });
        }
      });
    },
    goToRoom (row) {
      window.open(`${location.protocol}//${location.host}/#/${`broadcastRoomDetail?id=${row.roomId}&userId=${row.chat_account}`}`);
    },
    resHandle (res) {
      return res;
    },
    searchHandle (selectData) {
      console.log('处理搜索数据: ', selectData);
      // return selectData;
    }
  }
};
</script>

<style lang="scss" scoped>
.box{
  font-size: 18px;
  font-weight: bold;
  padding-bottom: 10px;
  margin-bottom: 20px;
  border-bottom: 1px solid #e8e8e8;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .num{
    font-weight: 400;
    margin-left: 20px;
    cursor: pointer;
  }
}
</style>
